import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'
import { SideBySideWidgetsType } from '../../types'
import { MAX_TOPIC_THEME_SUM } from '../constants'

const SideBySideOverComplexGuard: WidgetGuard = ({ widgetId, children }) => {
  const {
    topicInfos,
    pivotThemeInfos,
    tagNames,
    docNames
  } = useDashboardWidgetSetting<SideBySideWidgetsType>(widgetId)
  const { t } = useTranslation()

  const topicLength = topicInfos?.length ?? 0
  const themeLength = pivotThemeInfos?.length ?? 0
  const tagLength = tagNames?.length ?? 0
  const docLength = docNames?.length ?? 0

  const isOverComplex = topicLength + themeLength + tagLength + docLength > MAX_TOPIC_THEME_SUM

  return isOverComplex ? (
    <ErrorMessage>{t('tooManyMatrixedItems', { num: 10 })}</ErrorMessage>
  ) : (
    children
  )
}

export default SideBySideOverComplexGuard
